import React, { useEffect, useState } from "react";
import "../all css/bookcounsilling.css";
import {
  BsFillArrowLeftSquareFill,
  BsFillArrowRightSquareFill,
} from "react-icons/bs";
import Slider from "react-slick";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/footer";
import InterestedSectionMain from "../../components/interested section/InterestedSectionMain";
const visa_card_design = require("../../assets/aboutexplore/visa_id1.svg");
const visa_card_design1 = require("../../assets/aboutexplore/visa_id2.svg");
const circle_img = require("../../assets/counsil/anujS-circle.png");
const circle_img1 = require("../../assets/counselloer/ankita_circle.png");
const circle_img2 = require("../../assets/counselloer/devika_circle.png");
const circle_img3 = require("../../assets/counselloer/niva_circle.png");
const circle_img4 = require("../../assets/counselloer/divya.jpeg");
const circle_img5 = require("../../assets/counselloer/uma.png");
const circle_img6 = require("../../assets/counselloer/Khushali.jpg");
const circle_img7 = require("../../assets/counselloer/aniket.jpg");

const allVisaCousellorContent = [
  {
    visaCircleImg: circle_img1,
    visaClassName: "wow bounceInDown",
    duration: "2s",
    delay: ".2",
    firstVisaname: "Anvita",
    lastVisaName: "Bhavsar",
    subVisaName: "United States Of America ",
    aboutVisaContent: `A counselor and a sports person, who is making the country proud by representing the nation in Basketball. She is a graduate in B.com and is currently designated as a counselor at DWEC. Her dedication towards counseling students is impeccable..`,
  },

  {
    visaCircleImg: circle_img2,
    visaClassName: "wow bounceInUp",
    duration: "2s",
    delay: ".2",
    firstVisaname: "Devika",
    lastVisaName: "Padwal",
    subVisaName: "Canada ",
    aboutVisaContent: `A mechanical engineer by education who became an educational counsellor to help students achieve their dreams. Her compassion and empathy skills have enabled her to go above and beyond for her student.`,
  },
  {
    visaCircleImg: circle_img3,
    visaClassName: "wow bounceInDown",
    duration: "2s",
    delay: ".2",
    firstVisaname: "Niva",
    lastVisaName: "Kadakia",
    subVisaName: "United Kingdom & Ireland ",
    aboutVisaContent: `She is a master degree holder in Psychology. Being very enthusiastic about this field she is a good communicator and a precise observer, which are both very essential part of being a counselor. Her current designation in DWEC is senior counselor.`,
  },
  {
    visaCircleImg: circle_img4,
    visaClassName: "wow bounceInDown",
    duration: "2s",
    delay: ".2",
    firstVisaname: "Divya",
    lastVisaName: "Mary Jacob",
    //subVisaName: "B.com ",
    aboutVisaContent: `A management graduate Divya implements and oversee guidance program that provides students with a safe and non-judgmental way to voice their concerns or worries and help them develop career choices in accordance with their skills, talents and strengths. Coming in with a strong counselling mindset, she is making a positive difference to the students and life.`,
  },
  {
    visaCircleImg: circle_img5,
    visaClassName: "wow bounceInDown",
    duration: "2s",
    delay: ".2",
    firstVisaname: "Uma Shankar",
    lastVisaName: "Tripathi",
    //subVisaName: "B.com ",
    aboutVisaContent: `An expert Visa/Immigration specialist, who has in depth knowledge regarding study abroad, Immigration and all kinds of visa processes. He is a post graduate in computer application along with a bachelor’s degree in Economics. Added to this, he has a three year experience in overseas career counseling for government of Gujarat.`,
  },
  {
    visaCircleImg: circle_img6,
    visaClassName: "wow bounceInDown",
    duration: "2s",
    delay: ".2",
    firstVisaname: "Khushali",
    lastVisaName: "Upadhyay",
    //subVisaName: "B.com ",
    aboutVisaContent: `Khushali is our 'go-to-person' for everything at DWEC. From anonymous queries to arrival to acquisition, to student mentoring, visa/ immigration requirement to resources information. She is especially deft at analyzingand interpreting student data by conducting experiments. Previously she studied Computer application, and has gloriously worked with the finest in the fraternity. She hopes to do better here!`,
  },
  {
    visaCircleImg: circle_img7,
    visaClassName: "wow bounceInDown",
    duration: "2s",
    delay: ".2",
    firstVisaname: "Aniket",
    lastVisaName: "T.",
    //subVisaName: "B.com ",
    aboutVisaContent: `Aniket is a millennial impact strategist focused on mentoring young students and fulfilling their dreams. At DWEC, he is responsible for managing and heading counselling team. An engineering graduate with a commercial pilot license, he works collaboratively and spent time in training and development, strategy, motivating and nurturing a team of talented counsellors with planning and facilitate crisis intervention.`,
  },
];

function BookCounselling(props) {
  const customeSlider = React.useRef();

  const gotoNext = () => {
    customeSlider.current.slickNext();
  };

  const gotoPrev = () => {
    customeSlider.current.slickPrev();
  };

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    // autoplay: true,
    initialSlide: 0,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },

      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="nav_container">
        <Navbar fromPage="bookcounselling" />
      </div>

      <div className="visa_counselling_main_container">
        <div className="visa_counselling_under_main_container">
          <div className="visa_counselling_hero_section_img_text_container">
            <p className="title_of_video_counselling_text">
              LETS CONNECT NOW! <br />
            </p>
            <p className="extra_text_of_video_counselling">
              Connect with our team of maestro's over on video call for PERSONALISED SESSION
            </p>
          </div>
        </div>
      </div>
      <div className="counselloer_bg">
        <div className="visa_counselling_body_section">
          <div className="title_sub_title_Of_body_section">
            <p
              className="title_text wow pulse"
              data-wow-delay="500ms"
              data-wow-iteration="infinite"
              data-wow-duration="1s"
            >
              YOUR MENTORS
            </p>
            <p>
              
            </p>
          </div>

          <div className="slider_container_visa_counselloer">
            <Slider {...settings} ref={customeSlider}>
              {allVisaCousellorContent.map((perVisaCounseller) => {
                return (
                  <div
                    className={perVisaCounseller.visaClassName}
                    data-wow-duration={perVisaCounseller.duration}
                    data-wow-delay={perVisaCounseller.delay}
                    key={Math.random()}
                  >
                    <div
                      className="section_visa_counsellor_box_container"
                      key={Math.random()}
                    >
                      <img
                        className="top_design_view_img"
                        alt="design"
                        src={visa_card_design.default}
                      />

                      <div className="visa_content_all_contianer">
                        <div className="circle_visa_counselloer_img">
                          <img
                            src={perVisaCounseller.visaCircleImg}
                            alt="visa_counsellloer_img"
                            className="visa_counseller_img_self"
                          />
                        </div>
                        <p className="visa_id_name">
                          <span className="highlight_name_visa_text">
                            {perVisaCounseller.firstVisaname}
                          </span>{" "}
                          {perVisaCounseller.lastVisaName}
                        </p>
                        <p className="visa_sub_id_name">
                          {perVisaCounseller.subVisaName}
                        </p>
                        <p className="visa_extra_content_id">
                          {perVisaCounseller.aboutVisaContent.length > 241
                            ? perVisaCounseller.aboutVisaContent.substring(
                                0,
                                241
                              ) + "..."
                            : perVisaCounseller.aboutVisaContent}
                        </p>
                      </div>
                      <img
                        className="top_design_view_img1"
                        alt="design"
                        src={visa_card_design1.default}
                      />
                    </div>
                  </div>
                );
              })}
            </Slider>

            {/* slider section */}
            <div className="btn_left_right_visa_counselloer_container">
              <button
                className="prev_btn_counsellor same_btn_counsellor"
                onClick={() => gotoPrev()}
              >
                <BsFillArrowLeftSquareFill className="left_top_univercity_icon" />
              </button>

              <button
                className="next_btn_counsellor same_btn_counsellor"
                onClick={() => gotoNext()}
              >
                <BsFillArrowRightSquareFill className="left_top_univercity_icon" />
              </button>
            </div>

            <iframe
              width="100%"
              height="750px"
              src="https://dynamicworldeducationcommunitypvtltd-dynamicwec.zohobookings.in/portal-embed#/customer/114086000000017019"
              allowFullScreen="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            >
              {" "}
            </iframe>
          </div>
        </div>
      </div>
      <InterestedSectionMain />
      <Footer />
    </>
  );
}

export default BookCounselling;
